// extracted by mini-css-extract-plugin
module.exports = {"submitImage":"_1eBrq","trackingPixel":"_1MPFS"};